import React, { Fragment, useEffect, useRef, useState } from "react";
import { Button, FormGroup, Label } from 'reactstrap';
import Select, { components } from "react-select";

const OccassionTable = (props) => {
    const { setValue, trigger, settingOccassions, settingSubOccassions, occassionRows, setOccassionRows } = props;
        
    // New: duplicate tracking state
    const [duplicateIndices, setDuplicateIndices] = useState([]);

    const handleRowChange = (idx, field, value) => {
        // If occasion category changes, also reset the sub-occasion ids so the sub-select refreshes
        if (field === 'occasion_id') {
            setOccassionRows(prev => prev.map((row, i) => i === idx ? { ...row, occasion_id: value, occasion_sub_ids: [] } : row));
        } else {
            setOccassionRows(prev => prev.map((row, i) => i === idx ? { ...row, [field]: value } : row));
        }
    };

    const handleAddRow = () => {
        setOccassionRows(prev => ([...(prev || []), { occasion_id: '', occasion_sub_ids: [] }]));
    };

    const handleRemoveRow = (idx) => {
        setOccassionRows(prev => prev.length > 0 ? prev.filter((_, i) => i !== idx) : prev);
    };

    useEffect(() => {
        setValue("occassions", occassionRows);
        trigger("occassions");
    }, [occassionRows]);
        
    // New: detect duplicate rows & expose a form-level flag
    useEffect(() => {
        const keyMap = {};
        (occassionRows || []).forEach((row, idx) => {
            const key = `${row.occasion_id || ''}`;
            const isEmpty = !row.occasion_id && (!row.occasion_sub_ids || row.occasion_sub_ids.length === 0);
            if (isEmpty) return; // ignore totally empty rows
            if (!keyMap[key]) keyMap[key] = [];
            keyMap[key].push(idx);
        });
        const duplicates = new Set();
        Object.values(keyMap).forEach(arr => { if (arr.length > 1) arr.forEach(i => duplicates.add(i)); });
        const dupArray = Array.from(duplicates);
        setDuplicateIndices(dupArray);
        const hasDuplicates = dupArray.length > 0;
        if (setValue) setValue("occassions_has_duplicates", hasDuplicates);
        if (trigger) trigger("occassions_has_duplicates");
    }, [occassionRows, setValue, trigger]);

    return (
        <FormGroup>
            <Label className="form-label ai-form-heading">Occasions</Label>
            <table className="table table-bordered table-sm align-middle">
                <thead>
                    <tr>
                        <th style={{ width: '40%' }}>Occasion Category</th>
                        <th style={{ width: '40%' }}>Sub-Occasions</th>
                        <th style={{ width: '20%' }}>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {(occassionRows || []).map((row, idx) => {
                        const isDuplicate = duplicateIndices.includes(idx);

                        const selectErrorStyles = {
                            control: (base, state) => ({
                                ...base,
                                borderColor: isDuplicate ? '#dc3545' : base.borderColor,
                                boxShadow: isDuplicate ? '0 0 0 1px rgba(220,53,69,0.12)' : base.boxShadow,
                                '&:hover': { borderColor: isDuplicate ? '#dc3545' : base.borderColor },
                            })
                        };

                        return (
                            <tr key={idx}>
                                <td>
                                    <Select
                                        placeholder="Select Occasion"
                                        getOptionValue={option => option.id}
                                        getOptionLabel={option => option.name}
                                        options={settingOccassions}
                                        value={settingOccassions.find(opt => opt.id === row.occasion_id) || null}
                                        onChange={selected => handleRowChange(idx, 'occasion_id', selected ? selected.id : '')}
                                        styles={selectErrorStyles}
                                    />
                                </td>
                                <td>
                                    <Select
                                        placeholder="Select Sub-Occasion"
                                        isMulti
                                        isDisabled={!row.occasion_id} // disable until an occasion is selected
                                        getOptionValue={option => option.id}
                                        getOptionLabel={option => option.name}
                                        options={settingSubOccassions.filter(opt => opt.occasion_id === row.occasion_id)}
                                        value={settingSubOccassions.filter(opt => (row.occasion_sub_ids || []).includes(opt.id))}
                                        onChange={selected => handleRowChange(idx, 'occasion_sub_ids', selected ? selected.map(s => s.id) : [])}
                                    />
                                </td>
                                <td className="text-center">
                                    <Button 
                                        color="danger" 
                                        size="sm" 
                                        onClick={() => handleRemoveRow(idx)} 
                                        // disabled={occassionRows.length === 1}
                                    ><i className="fa fa-trash" /></Button>
                                    {isDuplicate && <div className="text-danger small mt-1">Duplicate row</div>}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
            <Button color="success" size="sm" className="mt-2" onClick={handleAddRow}><i className="fa fa-plus" /> Add Row</Button>
        </FormGroup>
    );
};

export default OccassionTable;
